<template>
    <div style="height: 100%; padding-bottom: 18px">
        <div class="sa-accordion-wrapper">
            <form>
                <div class="sa-accordion">
                    <input class="sa-accordion-input" type="radio" name="prescrizione-radio-a"
                        id="prescrizione-farmaco-radio-a" value="1" checked="checked" />
                    <label class="sa-accordion-label" for="prescrizione-farmaco-radio-a">
                        Farmaci
                        <b-button size="sm"
                            variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn"
                            @click="onClickNuovaPrescrizioneFarmacologica()">
                            <i class="fas fa-plus"></i>
                            Nuova Prescrizione
                        </b-button>
                        <b-form-checkbox class="pull-right sa-accordion-btn" v-model="mostraTutte" size="lg" switch>
                            <span
                                style="font-size: 1rem; vertical-align: middle; height: 100%; display: inline-block; margin-top: -3px; margin-right: 10px">Mostra
                                tutte</span>
                        </b-form-checkbox>

                        <!--- <b-button size="sm" variant="outline-purple outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickStampa()">
              <b-icon icon="printer" />
              Stampa
            </b-button>-->
                    </label>
                    <div class="sa-accordion-content">
                        <div class="b-table-sticky-header">
                            <b-table sticky-header ref="table" stacked="lg" striped hover :items="elencoFarmaci"
                                :fields="fieldsPrescrizioniFarmacologiche" :current-page="1" :per-page="perPage"
                                sort-icon-left head-variant="light" class="sa-b-table">
                                <template #cell(index)="row">
                                    <span> {{ row.index + 1 }} </span>
                                </template>
                                <template v-slot:cell(prescrizione)="{ item }">
                                    <span v-html="getTestoHtmlNomeAttivita(item)"></span>
                                </template>
                                <template v-slot:cell(note)="{ item }">
                                    <span v-html="item.note"></span>
                                </template>
                                <template v-slot:cell(dataInizio)="{ item }">
                                    <span style="display: inline-block; white-space: nowrap">Inizio: {{
                                        formatDate(item.dataInizio) }}</span><br />
                                    <span style="display: inline-block; white-space: nowrap">Fine: {{
                                        formatDate(item.dataFine) }}</span>
                                </template>
                                <template v-slot:cell(actions)="row">
                                    <b-container class="bv-example-row">
                                        <b-button v-b-tooltip.hover size="sm" variant="outline-primary no-text"
                                            title="Modifica Pianificazione"
                                            @click="onClickEditPrescrizioneFarmacologica(row.item, row.index, $event.target)"
                                            class="mr-1 no-text">
                                            <b-icon icon="pencil"></b-icon>
                                        </b-button>
                                        <b-button size="sm" v-b-tooltip.hover title="Concludi/Sospendi"
                                            variant="outline-purple sa-margin-left float-sm-left"
                                            @click="onClickCambioStato(row.item, row.index, $event.target)"><i
                                                class="fas fa-exchange-alt"></i> </b-button>
                                    </b-container>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
                <div class="sa-accordion">
                    <input class="sa-accordion-input" type="radio" name="prescrizione-radio-a"
                        id="prescrizione-prestazione-radio-a" value="2" />
                    <label class="sa-accordion-label" for="prescrizione-prestazione-radio-a">
                        Prestazioni
                        <b-button size="sm"
                            variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn"
                            @click="onClickNuovaPrescrizionePrestazione()">
                            <i class="fas fa-plus"></i>
                            Prescrivi Prestazione
                        </b-button>
                    </label>
                    <div class="sa-accordion-content">
                        <div class="b-table-sticky-header">
                            <b-table sticky-header ref="table" stacked="lg" striped hover
                                :items="prescrizioniPrestazioni" :fields="fieldsPrescrizioniPrestazioni"
                                :current-page="1" :per-page="perPage" sort-icon-left head-variant="light"
                                class="sa-b-table">
                                <template v-slot:cell(note)="{ item }">
                                    <span v-html="item.note"></span>
                                </template>
                                <template v-slot:cell(actions)="row">
                                    <b-container class="bv-example-row">
                                        <b-button v-b-tooltip.hover size="sm" variant="outline-primary no-text"
                                            title="Modifica Pianificazione"
                                            @click="onClickEditPrescrizionePrestazioni(row.item, row.index, $event.target)"
                                            class="mr-1 no-text">
                                            <b-icon icon="pencil"></b-icon>
                                        </b-button>
                                    </b-container>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <sa-modal-loading ref="saModalLoading" />
        <!-- <print-component v-show="false" ref="cmpPrint" :reportName="reportName" :printData="printData"></print-component> -->
        <rsa-paziente-prescrizione-farmaci-edit-modal-component
            ref="mdlRsaPazientePrescrizioneFarmaciEditModalComponent"
            @afterSave="onAfterSaveRsaPazientePrescrizioneFarmaciEditModalComponent"></rsa-paziente-prescrizione-farmaci-edit-modal-component>
        <rsa-paziente-prescrizione-farmaco-edit-modal-component
            ref="mdlRsaPazientePrescrizioneFarmacoEditModalComponent"
            @afterSave="onAfterSaveRsaPazientePrescrizioneFarmacoEditModalComponent"
            @afterCloseModal="onAfterCloseModalPrescrizioniEdit"></rsa-paziente-prescrizione-farmaco-edit-modal-component>
        <rsa-aree-pianificazione-edit-component ref="cmpRsaAreePianificazioneEditComponent"
            @afterSaveRequest="onAfterSaveRequestRsaAreePianificazioneComponent"></rsa-aree-pianificazione-edit-component>
        <prescrizione-farmaco-component ref="mdlPrescrizioneFarmacoComponent"
            @afterSava="onAfterSaveMdlPrescrizioneFarmacoComponent"></prescrizione-farmaco-component>
        <prescrizione-specialistica-component ref="mdlPrescrizioneSpecialisticaComponent"
            @afterSava="onAfterSaveMdlPrescrizioneSpecialisticaComponent"></prescrizione-specialistica-component>
        <rsa-prescrizioni-cambio-stato-modal-component ref="cmpPrescrizioniCambioStato"
            @cambioStatoSuccess="onCambioStatoSuccess"></rsa-prescrizioni-cambio-stato-modal-component>
    </div>
</template>

<script>
import moment from "moment";
import RsaAreePianificazioneEditComponent from "../RsaAreePianificazioneEditComponent.vue";
import RsaPazientePrescrizioneFarmacoEditModalComponent from "../../../rsapaziente/components/RsaPazientePrescrizioneFarmacoEditModalComponent.vue";
import PrescrizioneFarmacoComponent from "../../../../utility/components/PrescrizioneFarmacoComponent.vue";
import PrescrizioneSpecialisticaComponent from "../../../../utility/components/PrescrizioneSpecialisticaComponent.vue";
import axios from "axios";
import UtilityMixin from "../../../../utility/UtilityMixin";
import { SaModalLoading } from "../../../../../template/components/modal";
import RsaPrescrizioniCambioStatoModalComponent from "./RsaPrescrizioniCambioStatoModalComponent.vue";
import RsaPazientePrescrizioneFarmaciEditModalComponent from "../../../rsapaziente/components/RsaPazientePrescrizioneFarmaciEditModalComponent.vue";
// import PrintComponent from "../../../../utility/components/PrintComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { RsaPrescrizioniCambioStatoModalComponent, RsaAreePianificazioneEditComponent, RsaPazientePrescrizioneFarmacoEditModalComponent, PrescrizioneFarmacoComponent, PrescrizioneSpecialisticaComponent, SaModalLoading, RsaPazientePrescrizioneFarmaciEditModalComponent },
    data() {
        return {
            mostraTutte: false,
            perPage: 10000,
            pathResource: "/rsapazienteprescrizioni",
            pathResourcePazientePrescrizioniFarmacologiche: "/rsapazienteprescrizioni/farmaci",
            pathResourcePazientePrescrizioniPrestazioni: "/rsapazienteprescrizioni/prestazioni",
            pathResourcesAree: "/rsaaree",
            prescrizioniFarmacologiche: [],
            prescrizioniPrestazioni: [],
            jsonDataAccettazione: null,
            area: null,
            fieldsPrescrizioniFarmacologiche: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 0.5rem",
                },
                {
                    label: "Nome Farmaco",
                    key: "prescrizione",
                    // thStyle: "width: 50rem",
                    sortable: true,
                },
                {
                    label: "Programmazione",
                    key: "programmazione",
                    thStyle: "width: 5rem",
                    sortable: false,
                },
                // {
                // 	label: "Orari",
                // 	key: "programmazioneOrariDescrizioni",
                // 	thStyle: "width: 10rem",
                // 	sortable: true,
                // },
                {
                    label: "Indicazioni",
                    key: "note",
                    thStyle: "width: 20rem",
                    sortable: false,
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                    sortable: false,
                },
                {
                    label: "Inizio/Fine",
                    key: "dataInizio",
                    sortable: true,
                    thStyle: "width: 7rem",
                    formatter: (value) => {
                        return moment(value).format("DD-MM-YYYY");
                    },
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
            fieldsPrescrizioniPrestazioni: [
                {
                    label: "Nome Farmaco",
                    key: "prescrizione",
                    sortable: true,
                },
                {
                    label: "Q.tà",
                    key: "quantita",
                    thStyle: "width: 3rem",
                    sortable: true,
                },
                {
                    label: "Orari",
                    key: "frequenza",
                    thStyle: "width: 3rem",
                    sortable: true,
                },
                {
                    label: "Posologia",
                    key: "posologia",
                    thStyle: "width: 8rem",
                    sortable: true,
                },
                {
                    label: "Stato",
                    key: "stato",
                    sortable: true,
                    thStyle: "width: 5rem",
                    //tdClass: "text-right",
                },
                {
                    label: "Note",
                    key: "note",
                    sortable: true,
                },
                {
                    label: "Data Inizio",
                    key: "dataInizio",
                    sortable: true,
                    thStyle: "width: 7rem",
                    formatter: (value) => {
                        return moment(value).format("DD-MM-YYYY");
                    },
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    mounted() {
        this.loadAree();
    },
    computed: {
        elencoFarmaci() {
            return this.mostraTutte ? this.prescrizioniFarmacologiche : this.prescrizioniFarmacologiche.filter((e) => e.statoAttuale != "CONCLUSA");
        },
    },
    methods: {
        getTestoHtmlNomeAttivita(prescrizione) {
            let returnValue = prescrizione.prescrizione;
            if (prescrizione.tipo === "SOLUZIONE" || prescrizione.tipo === "ELASTOMERO") {
                if (prescrizione.params != "{}") {
                    let params = JSON.parse(prescrizione.params);
                    params.viaSomministrazione;
                    params.durata;
                    returnValue += `Via Somministrazione: <b>${params.viaSomministrazione}</b>`;
                    returnValue += `<br/>Durata: <b>${params.durata}</b>`;
                }
            }
            return returnValue;
        },

        getPrescrizioneHtml(prescrizione) {
            let htmlContent = "";
            let prescrizioneHtml = prescrizione.split(/\\n/g);
            prescrizioneHtml.forEach((element, index) => {
                if (index === 0) {
                    htmlContent += "<p><strong>" + element + "</strong></p><ul>";
                } else if (index === prescrizioneHtml.length - 1) {
                    htmlContent += "<li>" + element + "</li>" + "</ul>";
                } else {
                    htmlContent += "<li>" + element + "</li>";
                }
            });
            console.log(prescrizione.params);

            return htmlContent;
        },
        loadAree() {
            let me = this;

            let link = process.env.VUE_APP_PATH_API + me.pathResourcesAree + "/codicearea/SMT";
            axios
                .get(link)
                .then((response) => {
                    me.area = response.data.data;
                })
                .catch(() => { });
        },
        loadPrescrizioniPaziente(jsonDataAccettazione) {
            let me = this;
            me.jsonDataAccettazione = jsonDataAccettazione;
            me.loadPrescrizioniFarmacologichePaziente();
            me.loadPrescrizioniPrestazioniPaziente();
        },
        loadPrescrizioniFarmacologichePaziente() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePazientePrescrizioniFarmacologiche;
            axios
                .get(link, { params: { idAccettazione: me.jsonDataAccettazione.id } })
                .then((response) => {
                    me.prescrizioniFarmacologiche = [];
                    me.prescrizioniFarmacologiche = response.data.data.list;
                })
                .catch((error) => {
                    UtilityMixin.methods.messaggeBoxError(this, error);
                });
        },
        loadPrescrizioniPrestazioniPaziente() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePazientePrescrizioniPrestazioni;
            axios
                .get(link, { params: { idAccettazione: me.jsonDataAccettazione.id } })
                .then((response) => {
                    me.prescrizioniPrestazioni = [];
                    me.prescrizioniPrestazioni = response.data.data.list;
                })
                .catch((error) => {
                    UtilityMixin.methods.messaggeBoxError(this, error);
                });
        },
        onClickNuovaPrescrizioneFarmacologica() {
            let prescrizione = {
                idAccettazione: this.jsonDataAccettazione.id,
                idPaziente: this.jsonDataAccettazione.id,
                dataInizio: new Date().getTime(),
                dataFine: null,
                alBisogno: false,
                salvavita: false,
                obbligoNota: false,
                misuraPressione: false,
                misuraGlicemia: false,
                modificabile: false,
                caricoPaziente: false,
                terapiaPsichiatrica: false,
                note: null,
                tipoPrestazione: "FARMACOLOGICA",
                tipo: null,
                programmazioneTipo: null,
                programmazioneGiorni: null,
                programmazioneOrari: null,
                programmazioneTipologia: null,
                prescrizioneFarmaci: [],
            };
            this.$refs.mdlRsaPazientePrescrizioneFarmaciEditModalComponent.show(prescrizione, this.jsonDataAccettazione);
            // let prescrisione = {
            //   id: null,
            //   idAccettazione: this.jsonDataAccettazione.id,
            //   idPaziente: this.jsonDataAccettazione.id,
            //   dataInizio: new Date().getTime(),
            //   dataFine: null,
            //   codiceProdotto: null,
            //   atcGmp: null,
            //   prescrizione: null,
            //   quantita: 0,
            //   frequenza: null,
            //   costo: 0,
            //   stato: null,
            //   note: null,
            //   tipoPrestazione: "FARMACOLOGICA",
            //   params: JSON.stringify({ formaFarmaceutica: null, listaOrari: [] }),
            // };
            // if (this.jsonDataAccettazione.statoAttuale === "DIMISSIONE" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" || this.jsonDataAccettazione.statoAttuale === "ASSENTE") {
            //   let messaggio = this.jsonDataAccettazione.statoAttuale === "DIMISSIONE" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
            //   this.$bvModal.msgBoxOk(messaggio, {
            //     title: "ATTENZIONE",
            //     size: "sm",
            //     okVariant: "outline-danger",
            //     headerClass: "sa-msg-header-danger",
            //     footerClass: "p-2 border-top-0",
            //     centered: true,
            //   });
            //   return;
            // } else {
            //   this.$refs.mdlRsaPazientePrescrizioneFarmacoEditModalComponent.show(this.jsonDataAccettazione, prescrisione);
            // }
        },
        onClickEditPrescrizioneFarmacologica(prescrizione) {
            this.loadEditData(prescrizione.id);
            //this.$refs.mdlRsaPazientePrescrizioneFarmacoEditModalComponent.show(this.jsonDataAccettazione, item);
        },
        onClickNuovaPrescrizionePrestazione() {
            let me = this;
            if (me.jsonDataAccettazione.statoAttuale === "DIMISSIONE" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" || me.jsonDataAccettazione.statoAttuale === "ASSENTE") {
                let messaggio = me.jsonDataAccettazione.statoAttuale === "DIMISSIONE" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                this.$bvModal.msgBoxOk(messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return;
            } else {
                me.$refs.mdlPrescrizioneSpecialisticaComponent.show(me.jsonDataAccettazione);
            }
        },
        onClickEditPrescrizionePrestazioni(item) {
            let me = this;
            me.$refs.mdlPrescrizioneSpecialisticaComponent.edit(me.jsonDataAccettazione, item);
        },
        loadEditData(id) {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResource + "/" + id, {}, me.loadEditDataSuccess, me.loadEditDataError);
        },

        loadEditDataSuccess(response) {
            this.$refs.mdlRsaPazientePrescrizioneFarmaciEditModalComponent.show(response.data.data, this.jsonDataAccettazione);
        },

        loadEditDataError(response) {
            console.log(response);
        },

        onAfterSaveMdlPrescrizioneFarmacoComponent() {
            let me = this;
            me.loadPrescrizioniFarmacologichePaziente();
        },
        onAfterSaveMdlPrescrizioneSpecialisticaComponent() {
            let me = this;
            me.loadPrescrizioniPrestazioniPaziente();
        },
        onAfterSaveRequestRsaAreePianificazioneComponent() { },

        onAfterSaveRsaPazientePrescrizioneFarmacoEditModalComponent() {
            let me = this;
            me.loadPrescrizioniFarmacologichePaziente();
        },
        onClickCambioStato(item) {
            let me = this;
            me.$refs.cmpPrescrizioniCambioStato.show(item);
        },
        onCambioStatoSuccess() {
            let me = this;
            me.loadPrescrizioniFarmacologichePaziente();
            me.loadPrescrizioniPrestazioniPaziente();
        },
        onAfterCloseModalPrescrizioniEdit() {
            let me = this;
            me.loadPrescrizioniFarmacologichePaziente();
        },
        onAfterSaveRsaPazientePrescrizioneFarmaciEditModalComponent() {
            let me = this;
            me.loadPrescrizioniFarmacologichePaziente();
        },
    },
};
</script>

<style></style>
